import React from 'react';
import PropTypes from 'prop-types';
import './draggable-row.scss';

const DraggableRow = ({ children, rowData, isDraggable = true, component: Row = 'tr', ...rowProps }) => {
  const handleDragStart = (e) => {
    if (!isDraggable) {
      e.preventDefault();
      return;
    }
    e.dataTransfer.setData('application/json', JSON.stringify(rowData));
    e.dataTransfer.effectAllowed = 'move';
  };

  return (
    <Row
      {...rowProps}
      className={`draggable-row ${isDraggable ? 'draggable' : ''}`}
      draggable={isDraggable}
      onDragStart={handleDragStart}
      data-testid="draggable-row"
    >
      {children}
    </Row>
  );
};

DraggableRow.propTypes = {
  // MUI can supply its row element while preserving the existing drag handlers.
  component: PropTypes.elementType,
  children: PropTypes.node.isRequired,
  rowData: PropTypes.object.isRequired,
  isDraggable: PropTypes.bool,
};

export default DraggableRow;
